import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectWhatsAppNumber, selectWhatsAppBusinessNumber } from '../redux/selectors/application-selectors';

const DEFAULT_MESSAGE_TEMPLATE = 'Hola, quiero más información sobre el producto <NOMBRE> - Ref: <NRO_REFERENCIA>';

export const buildWhatsAppDefaultMessage = (productName = '', productRefNumber = '') => {
  const name = productName ? `"${productName}"` : '';
  const ref = productRefNumber || '-';
  return DEFAULT_MESSAGE_TEMPLATE
    .replace('<NOMBRE>', name)
    .replace('<NRO_REFERENCIA>', ref);
};

const urlHasCustomMessage = (url) => {
  if (!url || typeof url !== 'string') return false;
  try {
    const lower = url.toLowerCase();
    return lower.includes('text=');
  } catch {
    return false;
  }
};

const appendMessageToWhatsAppUrl = (baseUrl, message) => {
  if (!baseUrl || !message) return baseUrl;
  if (urlHasCustomMessage(baseUrl)) return baseUrl;
  const encoded = encodeURIComponent(message);
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}text=${encoded}`;
};

const useWhatsAppUrl = (packageUrlWhatsapp = null, productName = null, productRefNumber = null) => {
  const whatsappNumber = useSelector(selectWhatsAppNumber);
  const whatsappBusinessNumber = useSelector(selectWhatsAppBusinessNumber);

  const finalWhatsAppNumber = whatsappBusinessNumber || whatsappNumber;
  const isBusiness = Boolean(whatsappBusinessNumber);

  return useMemo(() => {
    let whatsappUrl = null;

    if (finalWhatsAppNumber) {
      if (isBusiness) {
        whatsappUrl = `https://wa.me/${finalWhatsAppNumber}`;
      } else {
        whatsappUrl = `https://api.whatsapp.com/send/?phone=${finalWhatsAppNumber}`;
      }
    }

    const shouldAddDefaultMessage =
      (productName || productRefNumber) && !urlHasCustomMessage(whatsappUrl);
    if (whatsappUrl && shouldAddDefaultMessage) {
      const message = buildWhatsAppDefaultMessage(productName || '', productRefNumber || '');
      whatsappUrl = appendMessageToWhatsAppUrl(whatsappUrl, message);
    }

    return {
      whatsappUrl,
      isBusiness,
      finalPhoneNumber: finalWhatsAppNumber,
    };
  }, [
    isBusiness,
    finalWhatsAppNumber,
    productName,
    productRefNumber,
    whatsappNumber,
    whatsappBusinessNumber,
  ]);
};

export default useWhatsAppUrl;

